import { getNavigator } from './navigation';

const HeaderManagerHandler = {
  addAuthorization(config) {
    const Config = config;
    const token = localStorage.getItem('accessToken');
    if (token) {
      Config.headers.Authorization = `Bearer ${token}`;
    }
    const inviteToken = sessionStorage.getItem('inviteToken') || undefined;
    if (inviteToken) {
      Config.headers.Invitetoken = `Invitetoken ${inviteToken}`;
    }
    Config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return Config;
  },
  manageSuccessRequests(response, addNotification) {
    try {
      // Favorites/history are tracked silently in the background (a page visit,
      // a star toggle that already has its own visual feedback) -- they
      // shouldn't pop a toast on every navigation.
      const url = response?.config?.url || '';
      const isLinkTrackingCall = url.includes('/linkVisits') || url.includes('/linkFavorites');
      if (response?.config?.method !== 'get'
        && JSON.stringify(response.status).startsWith(2)
        && !isLinkTrackingCall
        && response?.data?.message !== 'Issue has been updated'
        && response?.data?.message !== 'Status has been updated'
      && response?.data?.message !== 'Backlog has been updated') addNotification('Action succeeded !');
      return response;
    } catch (err) {
      console.log(err);
      return response;
    }
  },
  logoutOnForbiddenError(error, addNotification, setOverQuota, setOverWorkspaceQuota) {
    try {
      if (error?.response?.status === 401 && !error?.response?.data?.success) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('firstTime');
        const navigate = getNavigator();
        if (navigate) {
          navigate('/login');
        } else {
          console.warn('Navigate not yet initialized');
        }
        return error;
      }
      if (error?.response?.status === 402) {
        const { key } = error.response.data || {};
        if (key === 'WORKSPACE_OVER_QUOTA' && setOverQuota) {
          const {
            workspaceDomain, currentCount, maxAllowed, isOwner,
          } = error.response.data;
          setOverQuota({
            workspaceDomain, currentCount, maxAllowed, isOwner,
          });
          return error;
        }
        if (key === 'WORKSPACE_COUNT_EXCEEDED' && setOverWorkspaceQuota) {
          const { ownedCount, maxAllowed, isOwner } = error.response.data;
          setOverWorkspaceQuota({ ownedCount, maxAllowed, isOwner });
          return error;
        }
      }
      console.log(error);
      addNotification(error?.response?.data?.message || error?.message);
      return error;
    } catch (err) {
      console.log(err);
      return null;
    }
  },
};

export default HeaderManagerHandler;
